module.exports = __webpack_public_path__ + "img/star-1.0.b2800e98.svg";